import React from 'react'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded'
import RefreshIcon from '@mui/icons-material/Refresh'
import { Box, Button, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export type ErrorStateProps = {
  title?: string
  description?: string
  onRetry?: () => void
  retryLabel?: string
  isRetrying?: boolean
  minHeight?: number | string
  onLogout?: () => void
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  title,
  description,
  onRetry,
  retryLabel,
  isRetrying = false,
  minHeight = 400,
  onLogout,
}) => {
  const { t } = useTranslation()

  return (
    <Box
      role="alert"
      display="flex"
      flexDirection="column"
      gap={2}
      justifyContent="center"
      alignItems="center"
      sx={{ width: '100%', minHeight, px: 2, position: 'relative', textAlign: 'center' }}
    >
      {onLogout ? (
        <Button
          color="inherit"
          onClick={onLogout}
          startIcon={<LogoutRoundedIcon />}
          sx={{ position: 'absolute', top: 20, right: 20 }}
        >
          {t('logout')}
        </Button>
      ) : null}
      <ErrorOutlineIcon sx={{ fontSize: 96, color: 'error.main' }} />
      <Typography variant="subtitle1" component="p" fontWeight={700}>
        {title ?? t('error-title')}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 420 }}>
        {description ?? t('error-description')}
      </Typography>
      {onRetry ? (
        <Button
          variant="contained"
          color="primary"
          onClick={onRetry}
          disabled={isRetrying}
          startIcon={<RefreshIcon />}
          sx={{ mt: 1 }}
        >
          {retryLabel ?? t('try-again')}
        </Button>
      ) : null}
    </Box>
  )
}
